 // const tabs = document.querySelectorAll('.tab');
 //    const tabContents = document.querySelectorAll('.tab-content');

 //    tabs.forEach((tab) => {
 //      tab.addEventListener('click', () => {
 //        const tabContentId = tab.getAttribute('data-tab-content');
 //        const tabContent = document.getElementById(tabContentId);
 //        tabContents.forEach((content) => content.classList.remove('active'));
 //        tabContent.classList.add('active');
 //        tabs.forEach((t) => t.classList.remove('active'));
 //        tab.classList.add('active');
 //      });
 //    });

document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.tab');
  const tabContents = document.querySelectorAll('.tab-content');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabContentId = tab.getAttribute('data-tab-content');
      const tabContent = document.getElementById(tabContentId);
      tabContents.forEach((content) => content.classList.remove('active'));
      tabContent.classList.add('active');
      tabs.forEach((t) => t.classList.remove('active'));
      tab.classList.add('active');
    });
  });

  const voiceIcons = document.querySelectorAll('.voice-icon');
  voiceIcons.forEach((icon, index) => {
    icon.addEventListener('click', () => {
      const audioId = `audio-${index + 1}`;
      const audio = document.getElementById(audioId);
      if (audio) {
        audio.play();
      }
    });
  });
});
